import React, { useEffect } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { loadNav } from "../../reducers/nav";
import { connect } from "react-redux";
//import icar_logo from "../../images/icar.png";
import { HELP_DESK } from "../../components/common/branding";
import { Box, Drawer, Hidden, List, makeStyles } from "@material-ui/core";
import {
  AlertCircle as AlertCircleIcon,
  PenTool as SettingsIcon,
  Users as UsersIcon,
  Calendar as CalendarIcon,
  MessageCircle as NotificationsIcon,
  Layers as CourseIcon,
  MessageSquare as CommunicationIcon,
  Hexagon as OrganizationIcon,
  Clock as Dashboard,
} from "react-feather";
import NavItem from "./NavItem";
import { OrganizationThemeState } from "../../context/OrganizationThemeContext";

const useStyles = makeStyles((theme) => ({
  mobileDrawer: {
    width: 256,
    backgroundColor: "#fff",
  },
  desktopDrawer: {
    width: 256,
    top: 0,
    height: "100%",
    backgroundColor: "#fff",
    boxShadow: "3px 0px 20px #00000014",
    border: "none",
  },
  avatar: {
    cursor: "pointer",
    width: 85,
    height: 85,
  },
  item: {
    display: "flex",
    paddingTop: 6,
    paddingLeft: 8,
    paddingBottom: 0,
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  submenu: {
    paddingLeft: "16px",
  },
}));

const JsonIconList = {
  Dashboard,
  SettingsIcon,
  CalendarIcon,
  NotificationsIcon,
  UsersIcon,
  CommunicationIcon,
  CourseIcon,
  AlertCircleIcon,
  OrganizationIcon,
};
const CustomDrawer = (props) => {
  const { onMobileClose, openMobile, loadNav, session } = props;
  const { themeLogin } = OrganizationThemeState();
  const classes = useStyles();
  const location = useLocation();
  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);
  let UserType = session && session.membership && session.membership.role.name;
  let srcLogo = themeLogin?.logo;

  let userfirst_name = session && session.first_name;
  let userfirst_email = session && session.email;

  let user_name_d = userfirst_name || userfirst_email;
  let view_role = session?.membership?.view_role?.name;

  const nav =
    session &&
    session.profile &&
    session.profile.permissions &&
    JSON.parse(session.profile.permissions);
  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <div className="logo__wrapper">
        <RouterLink to="/">
          <img
            className="logo__wrapper__img"
            alt="Brihha"
            src={srcLogo}
          />
        </RouterLink>
      </div>
      <Box p={0}>
        {user_name_d && UserType && (
          <h4
            style={{
              marginTop: "15px",
              padding: "5px 5px 5px 30px",
              fontSize: "15px",
              fontWeight: "600",
              color: "#444",
            }}
          >
            {" "}
            Welcome
          </h4>
        )}
        {user_name_d && UserType && (
          <h3
            style={{
              padding: "5px 5px 5px 30px",
              fontSize: "16px",
            }}
          >
            {" "}
            {user_name_d}{" "}
            <span
              style={{ fontSize: "12px", paddingLeft: "3px", color: "#EF4857" }}
            >
              {" "}
              {`${view_role}`}{" "}
            </span>{" "}
          </h3>
        )}

        <List style={{ marginTop: "8px", padding: "0" }}>
          {nav &&
            nav.length > 0 &&
            nav.map((item, index) => (
              <React.Fragment key={index}>
                {item.permission ? (
                  <NavItem
                    href={item.href}
                    key={item.title}
                    title={item.title}
                    icon={item.icon}
                  />
                ) : null}
                <List className={classes.submenu} disablePadding>
                  {item.childrens &&
                    item.childrens.map((children, index) => (
                      <React.Fragment key={index}>
                        {" "}
                        {children.permission ? (
                          <NavItem
                            href={children.href}
                            key={children.title}
                            title={children.title}
                            icon={children.icon}
                            iconName={children.icon}
                          />
                        ) : null}
                      </React.Fragment>
                    ))}
                </List>
              </React.Fragment>
            ))}
          {/* <NavItem
            className={"d-none"}
            href={"#"}
            title={"Video Conferencing"}
            icon={"video-conferencing"}
            iconName={"twes"}
          /> */}
          {nav && HELP_DESK && (
            <NavItem
              href={"#"}
              title={"Help Desk"}
              icon={"customer-support"}
              iconName={"twes"}
            />
          )}
        </List>
      </Box>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};
const mapStateToProps = (state) => ({
  session: state.session,
});

const mapDispatchToProps = (dispatch) => ({
  loadNav: () => dispatch(loadNav()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomDrawer);
